export const FLOW_BRANCH_CHANNEL = {
  ALL: 'all',
  WHATSAPP: 'whatsapp'
};

/** Overview modal filter: show both stacked lanes, or one channel. */
export const OVERVIEW_BRANCH_FILTER = {
  ALL_LANES: 'all_lanes',
  ALL: FLOW_BRANCH_CHANNEL.ALL,
  WHATSAPP: FLOW_BRANCH_CHANNEL.WHATSAPP
};

/** Shared active/inactive style for channel toggle buttons (editor and overview filter). */
export const channelButtonClass = (active) => (
  `tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1.5 tw-rounded-lg tw-border tw-text-xs tw-font-medium tw-cursor-pointer ${
    active
      ? 'tw-bg-blue-50 tw-border-blue-200 tw-text-blue-700'
      : 'tw-bg-white tw-border-gray-200 tw-text-gray-600 hover:tw-border-gray-300'
  }`
);

export const filterOverviewLanes = (lanes, branchFilter) => {
  if (!branchFilter || branchFilter === OVERVIEW_BRANCH_FILTER.ALL_LANES) {
    return lanes;
  }
  return lanes.filter((lane) => lane.channel === branchFilter
    || (branchFilter === OVERVIEW_BRANCH_FILTER.ALL && !lane.channel));
};

/** A lane with no steps would render only a channel header inside an empty block. */
export const visibleOverviewLanes = (lanes = []) => (
  lanes.filter((lane) => (lane.steps || []).length > 0)
);

export const findBranchByChannel = (intention, channel) => (
  (intention?.branches || []).find((branch) => branch.channel === channel) || null
);

export const hasChannelBranch = (intention, channel) => Boolean(findBranchByChannel(intention, channel));

export const stepsForChannel = (intention, channel) => {
  if (!intention) return [];
  if (channel && channel !== FLOW_BRANCH_CHANNEL.ALL) {
    return findBranchByChannel(intention, channel)?.steps || [];
  }
  return intention.steps || [];
};

export const applyStepsForChannel = (intention, channel, nextSteps) => {
  const base = intention || {};
  if (channel && channel !== FLOW_BRANCH_CHANNEL.ALL) {
    const branches = (base.branches || []).map((branch) => (
      branch.channel === channel ? { ...branch, steps: nextSteps } : branch
    ));
    return { ...base, branches };
  }
  return { ...base, steps: nextSteps };
};

export const replaceBranch = (intention, updatedBranch) => {
  const base = intention || {};
  const branches = base.branches || [];
  const exists = branches.some((branch) => String(branch.id) === String(updatedBranch.id));
  const nextBranches = exists
    ? branches.map((branch) => (String(branch.id) === String(updatedBranch.id) ? { ...branch, ...updatedBranch } : branch))
    : [...branches, updatedBranch];
  return { ...base, branches: nextBranches };
};

const sortStepsByIndex = (steps = []) => (
  [...steps].sort((a, b) => (a.index ?? 0) - (b.index ?? 0))
);

/**
 * Lanes for read-only overview (eye modal): one list when there is no channel
 * branch; otherwise default path then WhatsApp stacked with their step text.
 */
export const intentionOverviewLanes = (intention) => {
  const defaultSteps = sortStepsByIndex(intention?.steps || []);
  const whatsappBranch = findBranchByChannel(intention, FLOW_BRANCH_CHANNEL.WHATSAPP);

  if (!whatsappBranch) {
    return [{
      key: 'default',
      channel: null,
      enabled: true,
      steps: defaultSteps
    }];
  }

  return [
    {
      key: 'all',
      channel: FLOW_BRANCH_CHANNEL.ALL,
      enabled: true,
      steps: defaultSteps
    },
    {
      key: 'whatsapp',
      channel: FLOW_BRANCH_CHANNEL.WHATSAPP,
      enabled: Boolean(whatsappBranch.enabled),
      steps: sortStepsByIndex(whatsappBranch.steps || [])
    }
  ];
};
